import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import UList from "@insightfulscience/atomic-react/UList";
import LandingSimpleSectionStripped from "@insightfulscience/atomic-react/LandingElement/SimpleSectionStripped";
import { HubSpotForm } from "../HubSpotForm";
import { publicConfig } from "../config";

const { SB_CDN_BASE_URL, SB_CDN_HOST } = publicConfig;

const bg = `${SB_CDN_HOST}${SB_CDN_BASE_URL}/assets/images/geneious/section-try-for-free/bg.png`;

const LumaScientificIntelligencePlatformForm = () => {
	const [t] = useLocale("luma-scientific-intelligence-platform");

	return (
		<LandingSimpleSectionStripped
			utility={{
				bgColor: "dotmatics-8",
				bgImage: [{ url: bg, position: "left top", repeat: "no-repeat", size: "auto" }],
			}}
			spacing={{ sm: { py: 10 } }}
		>
			<Row>
				<Col md={6}>
					<Row>
						<Col md={10}>
							<Heading
								id="lumaScientificIntelligencePlatformForm-form"
								Tag="h2"
								sx={{ fontSize: "xl", fontColor: "white" }}
								spacing={{ mb: 6 }}
							>
								{t("TITLE")}
							</Heading>
							<Paragraph sx={{ fontColor: "white" }}>{t("SUBTITLE")}</Paragraph>
							<UList spacing={{ ml: 5 }}>
								<UList.Item bulletColor="white" sx={{ fontColor: "white" }}>
									<Paragraph>{t("LIST_ITEM_1")}</Paragraph>
								</UList.Item>
								<UList.Item bulletColor="white" sx={{ fontColor: "white" }}>
									<Paragraph>{t("LIST_ITEM_2")}</Paragraph>
								</UList.Item>
								<UList.Item bulletColor="white" sx={{ fontColor: "white" }}>
									<Paragraph>{t("LIST_ITEM_3")}</Paragraph>
								</UList.Item>
							</UList>
						</Col>
					</Row>
				</Col>
				<Col md={6}>
					<HubSpotForm
						target="lumaScientificIntelligencePlatformForm"
						formId={publicConfig.HUBSPOT_LUMA_SCIENTIFIC_INTELLIGENCE_PLATFORM_FORM_ID}
						portalId={publicConfig.HUBSPOT_PORTAL_ID.toString()}
					/>
				</Col>
			</Row>
		</LandingSimpleSectionStripped>
	);
};

export default LumaScientificIntelligencePlatformForm;
